import { useEffect, useRef, useState } from "react";
import {
  ChatStep,
  ChatChunk,
  ContentBody,
  DownloadButton,
  ReferenceDocName,
  RedirectLink,
  ReferenceElement,
} from "./style";
import { DRIVE_BASE_PATH_REDIRECT } from "../../../../config";
import { ReferenceChunk, ReferenceHeader } from "../ReferenceChunk";

const mock = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
commodo consequat. Duis aute irure dolor in reprehenderit in`;

export const ChatMessage = ({
  left = false,
  loading = false,
  body = "",
  // body = mock,
  onLoad,
  docHeaderInfo,
  references = [
    // {
    //   filename: "manual.pdf",
    //   page: 43,
    //   score: 3,
    // },
  ],
  position = "15",
  openModal,
  last = false,
}) => {
  const ref = useRef();
  const btnref = useRef();
  const [height, setHeight] = useState("-4vw");
  useEffect(() => {
    setHeight(
      ref.current.getBoundingClientRect().height +
        (references.length
          ? btnref.current.getBoundingClientRect().height * references.length
          : 0)
    );
    onLoad();
  }, [loading]);

  const referencePerPubblication = Object.entries(
    references.reduce((a, e) => {
      if (!e.filename) return a;
      if (!a[e.filename]) a[e.filename] = { pages: [], id: "" };
      a[e.filename].pages.push({ page: e.page, chunk: e.document });
      a[e.filename].id = e.id;
      return a;
    }, {})
  );

  return (
    <ChatStep {...{ left, last }}>
      <ChatChunk {...{ left, last, loading, contentHeight: height }}>
        <ContentBody
          dangerouslySetInnerHTML={{
            __html: loading
              ? ""
              : body.replace("```html", "").replace("```", ""),
          }}
          ref={ref}
        ></ContentBody>

        {referencePerPubblication.map((data, index) => {
          const [filename, { pages, id }] = data;
          const redirectPath = DRIVE_BASE_PATH_REDIRECT.replace(
            "%FILE_ID%",
            id
          );
          return (
            <>
              {index === 0 ? <ReferenceHeader {...{ docHeaderInfo }} /> : ""}
              <ReferenceChunk
                {...{ filename, btnref, index, redirectPath, pages, openModal }}
              />
            </>
          );
        })}
      </ChatChunk>
    </ChatStep>
  );
};
